(function () {
  'use strict';

  function surface() {
    return document.body.classList.contains('b2b-partner') ? 'b2b' : 'dtc';
  }

  function context() {
    return {
      surface: surface(),
      market: window.ShopifyMarket && window.ShopifyMarket.country || '',
      currency: window.ShopifyMarket && window.ShopifyMarket.currency || '',
      path: window.location.pathname,
      device: window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
    };
  }

  function publish(name, detail) {
    var payload = Object.assign(context(), detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, rungne: payload });

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    }

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, payload);
    }
  }

  function sectionName(element) {
    var section = element && element.closest('[id^="shopify-section-"]');
    return section ? section.id.replace('shopify-section-', '') : '';
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('a, button');
    if (!target) return;

    if (target.dataset.r1Event) {
      publish('rungne_' + target.dataset.r1Event, {
        section: sectionName(target),
        category: target.dataset.r1Category || '',
        label: (target.textContent || '').trim().slice(0, 120),
        destination: target.href || ''
      });
    }

    if (target.dataset.b2bEvent) {
      publish('rungne_b2b_action', {
        section: sectionName(target),
        action: target.dataset.b2bEvent,
        destination: target.href || ''
      });
    }

    var productCard = target.closest('.product-card');
    if (productCard && target.closest('a')) {
      publish('rungne_product_card_click', {
        section: sectionName(target),
        product_id: productCard.getAttribute('data-main-id') || '',
        destination: target.href || ''
      });
    }

    if (target.matches('[href*="/search"], [href*="/products/"]') && target.closest('predictive-search, .predictive-search, .search-results')) {
      publish('rungne_search_result_click', {
        section: sectionName(target),
        label: (target.textContent || '').trim().slice(0, 120),
        destination: target.href || ''
      });
    }

    if (target.matches('[href*="checkout"], [name="checkout"], [data-checkout]')) {
      publish('rungne_checkout_start', { section: sectionName(target) });
    }

    if (/notify me when available/i.test(target.textContent || '')) {
      publish('rungne_bis_open', { section: sectionName(target) });
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.matches('form[action*="/cart/add"]')) {
      publish('rungne_add_to_cart', {
        section: sectionName(form),
        variant_id: form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value || '',
        quantity: form.querySelector('[name="quantity"]') && form.querySelector('[name="quantity"]').value || '1'
      });
    }

    if (form.closest('[data-bis], .back-in-stock, [class*="notify"]')) {
      publish('rungne_bis_submit', { section: sectionName(form) });
    }

    if (form.closest('[data-ss27], .ss27-preorder')) {
      publish('rungne_b2b_preorder_submit', { section: sectionName(form) });
    }
  });

  document.addEventListener('change', function (event) {
    var field = event.target;
    if (field.matches('form[action*="/cart/add"] [name="id"], variant-selects input, variant-selects select')) {
      publish('rungne_variant_select', {
        section: sectionName(field),
        value: field.value || ''
      });
    }

    if (surface() === 'b2b' && field.matches('[name="quantity"], quantity-input input')) {
      publish('rungne_b2b_quantity_select', {
        section: sectionName(field),
        value: field.value || ''
      });
    }
  });

  document.addEventListener('klaviyoForms', function (event) {
    if (!event.detail || event.detail.type !== 'Submit') return;
    publish('rungne_signup_submit', { form_id: event.detail.formId || '' });
  });

  if (document.body.classList.contains('template-product')) {
    publish('rungne_pdp_view', {
      product_id: document.querySelector('[data-product-id]') && document.querySelector('[data-product-id]').getAttribute('data-product-id') || ''
    });
  }
})();

